import styled from 'styled-components';
import { Colors } from '../../colors/Colors';

export const Page = styled.main`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-inline: 1rem;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 3rem;
	max-width: 720px;
	margin-top: 10rem;
	padding-bottom: 20rem;
`;

export const Header = styled.h1`
	color: ${Colors.mainColor};
	font-family: 'Poppins' !important;
	font-size: 48px;
	font-weight: 900;
`;

export const Text = styled.p`
	color: ${Colors.mainColor};
	font-family: 'Roboto' !important;
	font-size: 16px;
	font-weight: 400;
	text-align: center;
`;

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
	width: 100%;
`;

export const TextArea = styled.textarea`
	width: 100%;
	resize: none;
	height: 142px;
	border: none;
	background-color: #f5f5f5;
	border-radius: 8px;
	padding: 1.5rem 2rem;
	font-family: 'Roboto';
	font-size: 16px;

	&::placeholder {
		color: #999692;
	}
`;

export const SubmitButton = styled.button`
	display: flex;
	align-items: center;
	gap: 1rem;
	background-color: ${Colors.lightGreen};
	color: white;
	border: none;
	font-size: 20px;
	font-weight: 400;
	padding: 0.8rem 5rem;
	border-radius: 999px;
	font-family: 'Roboto';
	cursor: pointer;
`;
